import { getFirebaseBackend } from "helpers/firebase_helper";
// import { postFakeLogin, postJwtLogin } from "helpers/fakebackend_helper";
import { loginSuccess, apiError, logoutUserSuccess, resetLoginFlag } from "./reducer";
import * as AuthApi from "../../../services/authApi";

export const loginuser = (user: any, history: any) => async (dispatch: any) => {
    try {
        const response = await AuthApi.login({
            identifier: user.email,
            password: user.password
        });

        if (response.jwt && response.user) {
            if(response?.user?.role?.type !== "partner") {
              dispatch(apiError("Authentication failed"));
              return;
            }
            
            localStorage.setItem("authUser", JSON.stringify(response));
            dispatch(loginSuccess(response));
            history('/transactions');
          } else {
            dispatch(apiError("Authentication failed"));
          }
    } catch (error: any) {
        const errorMessage = error.response?.data?.error?.message || 
        'An error occurred during login';

        dispatch(apiError(errorMessage));
    }
}

export const logoutUser = () => async (dispatch: any) => {
    try {
        localStorage.removeItem("authUser");

        const fireBaseBackend = getFirebaseBackend();
        if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
            const response = fireBaseBackend.logout;
            dispatch(logoutUserSuccess(response));
        } else {
            dispatch(logoutUserSuccess(true));
        }

    } catch (error) {
        dispatch(apiError(error));
    }
};

export const resetLoginMsgFlag = () => {
    try {
        const response = resetLoginFlag();
        return response;
    } catch (error) {
        return error;
    }
};


export const socialLogin = (type: any, history: any) => async (dispatch: any) => {
    try {
        let response: any;

        if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
            const fireBaseBackend = getFirebaseBackend();
            response = fireBaseBackend.socialLoginUser(type);
        }

        const socialdata = await response;
        if (socialdata) {
            sessionStorage.setItem("authUser", JSON.stringify(socialdata));
            dispatch(loginSuccess(socialdata));
            history('/dashboard');
        }

    } catch (error) {
        dispatch(apiError(error));
    }
};